import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS, ICandidateJobApplicationStash } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class CandidateApplicationStashRepository extends CollectionRepository<ICandidateJobApplicationStash> {
  protected COLLECTION = COLLECTIONS.CANDIDATE_APPLICATION_STASH
}
